import React from 'react';

const DollarPhone: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 2.66666C9.38124 2.66666 8.78775 2.91249 8.35017 3.35007C7.91258 3.78766 7.66675 4.38115 7.66675 4.99999V35C7.66675 35.6188 7.91258 36.2123 8.35017 36.6499C8.78775 37.0875 9.38124 37.3333 10.0001 37.3333H30.0001C30.6189 37.3333 31.2124 37.0875 31.65 36.6499C32.0876 36.2123 32.3334 35.6188 32.3334 35V4.99999C32.3334 4.38115 32.0876 3.78766 31.65 3.35007C31.2124 2.91249 30.6189 2.66666 30.0001 2.66666H10.0001ZM6.93595 1.93586C7.74861 1.1232 8.85081 0.666656 10.0001 0.666656H30.0001C31.1494 0.666656 32.2516 1.1232 33.0642 1.93586C33.8769 2.74852 34.3334 3.85072 34.3334 4.99999V35C34.3334 36.1493 33.8769 37.2515 33.0642 38.0641C32.2516 38.8768 31.1494 39.3333 30.0001 39.3333H10.0001C8.85081 39.3333 7.74861 38.8768 6.93595 38.0641C6.12329 37.2515 5.66675 36.1493 5.66675 35V4.99999C5.66675 3.85072 6.12329 2.74852 6.93595 1.93586Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 7.33331V32.6666H19V7.33331H21Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9345 9.82004C21.5627 9.63169 24.563 10.3068 26.1066 11.1553L26.983 11.637L26.0196 13.3897L25.1433 12.908C23.9853 12.2715 21.3797 11.6499 19.0775 11.8149C17.9347 11.8968 16.9922 12.1652 16.3614 12.6099C15.7842 13.0168 15.4133 13.6032 15.4133 14.5533C15.4133 15.717 15.8951 16.4484 16.6931 17.0336C17.559 17.6684 18.7564 18.0984 20.1328 18.5571C20.2267 18.5884 20.3215 18.6199 20.4172 18.6516C21.6469 19.0594 23.0114 19.5119 24.0731 20.196C25.2882 20.979 26.22 22.1387 26.22 23.9183C26.22 25.5063 25.6937 26.7701 24.7336 27.6779C23.8 28.5606 22.5507 29.0176 21.249 29.2133C18.6607 29.6022 15.512 29.0125 12.995 28.1077L12.054 27.7694L12.7305 25.8873L13.6716 26.2256C16.0179 27.0691 18.8126 27.5569 20.9518 27.2355C22.0138 27.0759 22.8243 26.7307 23.3595 26.2246C23.8683 25.7436 24.22 25.0321 24.22 23.9183C24.22 22.9963 23.8009 22.3999 22.9897 21.8772C22.1506 21.3365 21.0186 20.9598 19.7033 20.5221C19.6361 20.4997 19.5685 20.4772 19.5004 20.4545C18.1752 20.0128 16.671 19.4974 15.5105 18.6465C14.2824 17.7459 13.4133 16.4513 13.4133 14.5533C13.4133 12.9459 14.1061 11.7528 15.209 10.9753C16.2582 10.2356 17.6121 9.91481 18.9345 9.82004Z"
      />
    </svg>
  );
};

export default DollarPhone;
